// extracted by mini-css-extract-plugin
export default {"text":"MessageProgress_text__Vu+XQ"};